import axios from '@beastshop/axios-m'
import { app, android } from '@beastshop/browser'
// import cookie from 'js-cookie'
import {btoa} from 'b2a'
import sa from '../lib/sa'

export default (options) => {
  if(!app()) {
    const {
      getUTMProp,
      getAnonymousID,
      current_page_id,
      current_page_name,
      current_page_type
    } = sa

    let utmData = {}
    let cache_utm_source = null

    try {
      utmData = getUTMProp()
      cache_utm_source = window.localStorage.getItem('the_utm_source') || null
    }
    catch (err) {
      
    }
  
    utmData['theLatestUtmSource'] = cache_utm_source ? JSON.parse(cache_utm_source).value : ''
    // const userId = cookie.get('_b_m_c')
    const sensors = {
      // userId: userId || '',
      anonymousId: getAnonymousID(),
      currentPageType: current_page_type,
      currentPageName: current_page_name,
      currentPageId: current_page_id,
      ...utmData
    }
    options.headers = {
      'TBS-Sensors': btoa(JSON.stringify(sensors))
    }
  }
  if (android()) {
    let url = options.url
    options.url = url.replace('/app', 'app') //兼容安卓
  }
  return axios(options)
}



// WEBPACK FOOTER //
// ./static/axios-mock/index.js